define('store/actions/creators',["exports", "./types"], function (exports, _types) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.serverAddRealm = exports.sessionRemoveInfo = exports.sessionAddInfo = undefined;
    var sessionAddInfo = exports.sessionAddInfo = function sessionAddInfo(_ref) {
        var realm = _ref.realm,
            sessionHandle = _ref.sessionHandle;
        return {
            type: _types.SESSION_ADD_INFO,
            realm: realm,
            sessionHandle: sessionHandle
        };
    }; /*
        * Copyright 2016-2017 ForgeRock AS. All Rights Reserved
        *
        * Use of this code requires a commercial software license with ForgeRock AS.
        * or with one of its affiliates. All use shall be exclusively subject
        * to such license between the licensee and ForgeRock AS.
        */

    var sessionRemoveInfo = exports.sessionRemoveInfo = function sessionRemoveInfo() {
        return {
            type: _types.SESSION_REMOVE_INFO
        };
    };

    var serverAddRealm = exports.serverAddRealm = function serverAddRealm(realm) {
        return {
            type: _types.SERVER_ADD_REALM,
            realm: realm
        };
    };
});

